<template>
  <a-list item-layout="vertical" size="large" :data-source="listData" class="financial-list">
    <a-list-item slot="renderItem" key="item.title" slot-scope="item, index">
      <img
        slot="extra"
        alt="illustration"
        :src="item.image"
        class="financial-item-img"
      />
      <a-list-item-meta :description="item.description">
        <div slot="title" class="font-web financial-item-title-wrapper">
          <span class="financial-item-title">{{ item.title }}</span>
          <a-button class="mt-0 mb-0 access-btn" type="link" :href="item.url" target="_blank">
            <a-icon type="link" /> เข้าใช้งานระบบ
          </a-button>
        </div>
      </a-list-item-meta>
      <div class="financial-item-content">
        <div class="content-section mb-10">
          <h4 class="font-web section-label">รายละเอียด</h4>
          <p class="font-web mt-0 mb-0">{{ item.content }}</p>
        </div>
        <div class="content-section mb-15">
          <h4 class="section-label font-web">คุณสมบัติหลัก</h4>
          <ul class="feature-list font-web">
            <li v-for="(feature, fIdx) in item.features" :key="fIdx">
              <a-icon type="check-circle" theme="filled" class="feature-icon" />
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        {
          title: 'E-Payroll',
          description: 'Electronic Payroll System (Mahidol University)',
          content: 'E-Payroll เป็นระบบสำหรับบุคลากรมหาวิทยาลัยมหิดล ใช้ตรวจสอบและพิมพ์เอกสาร ใบแจ้งรายได้, ใบแจ้งผลการเลื่อนเงินเดือน และหนังสือรับรองการหักภาษี ณ ที่จ่าย',
          features: [
            'ใช้ตรวจสอบและพิมพ์เอกสาร ใบแจ้งรายได้, ใบแจ้งผลการเลื่อนเงินเดือน และหนังสือรับรองการหักภาษี ณ ที่จ่ายสำหรับบุคลากร',
            'ใช้ตรวจสอบปฏิทินการจ่ายเงินเดือนของบุคลากร'
          ],
          url: 'https://e-payroll.mahidol.ac.th',
          network: 'Intranet',
          image: '/images/hri_dashboard/on_payroll.png'
        },
        {
          title: 'Tax',
          description: 'E-Filing Revenue Department',
          content: 'บริการยื่นแบบและนำส่งข้อมูลการยื่นแบบผ่านอินเทอร์เน็ต โดยสามารถยื่นได้สำหรับผู้เสียภาษี และสำนักงานบัญชีตัวแทน (Tax Agent) ทั้งนี้ระบบยังสามารถรองรับการยื่นแบบทุกประเภท ทั้งฉบับปกติและเพิ่มเติม ภายในกำหนดและเกินกำหนดเวลา',
          features: [
            'ใช้ภาษีเงินได้บุคคลธรรมดา, ภาษีเงินได้นิติบุคคล, ภาษีมูลค่าเพิ่ม, ภาษีธุรกิจเฉพาะ, ภาษีเงินได้หัก ณ ที่จ่าย, อากรแสตมป์, ภาษีมรดก และแบบแจ้งเงินได้ต่างด้าว'
          ],
          url: 'https://efiling.rd.go.th/rd-cms/',
          network: 'Internet',
          image: '/images/hri_dashboard/on_tax.png'
        }
      ]
    };
  }
};
</script>

<style scoped>
.financial-list {
  padding: 0 20px;
}
.financial-item-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}
.financial-item-title {
  font-size: 22px !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  margin-bottom: 0 !important;
}
.access-btn {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 0 !important;
  height: auto !important;
  color: #4285F4 !important;
}
.access-btn:hover {
  color: #1a1a2e !important;
  text-decoration: underline !important;
}
.financial-item-content {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
}
.section-label {
  font-size: 13px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.feature-list li {
  margin-bottom: 5px;
  display: flex;
  align-items: flex-start;
}
.feature-icon {
  color: #52c41a;
  margin-right: 8px;
  margin-top: 4px;
  font-size: 14px;
}
.financial-item-img {
  width: 180px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  object-fit: cover;
}
@media (max-width: 768px) {
  .financial-list {
    padding: 0 10px;
  }
  .financial-item-title {
    font-size: 20px !important;
  }
  .financial-item-img {
    width: 100% !important;
    max-width: 240px;
    margin-top: 10px;
  }
  ::v-deep .ant-list-item-extra {
    margin-left: 0 !important;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .financial-item-title-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
  .financial-item-img {
    max-width: 100%;
  }
}
.mb-15 {
  margin-bottom: 15px;
}
</style>
